import React, { useId } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export interface PremiumSelectOption {
  value: string;
  label: string;
}

interface PremiumSelectProps {
  id?: string;
  label: string;
  value: string;
  options: PremiumSelectOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  wrapperClassName?: string;
  inputClassName?: string;
}

const PremiumSelect: React.FC<PremiumSelectProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  placeholder = 'Selecione...',
  required,
  disabled = false,
}) => {
  const generatedId = useId().replace(/:/g, '');
  const controlId = id || `premium-select-${generatedId}`;
  const labelId = `${controlId}-label`;

  return (
    <FormControl fullWidth variant="filled" disabled={disabled} required={required}>
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        id={controlId}
        labelId={labelId}
        value={value}
        displayEmpty
        onChange={(event) => onChange(event.target.value as string)}
        renderValue={(selected) => {
          const opt = options.find((o) => o.value === selected);
          if (!opt) {
            return <span style={{ color: 'var(--mui-select-placeholder, #999)' }}>{placeholder}</span>;
          }
          return opt.label;
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PremiumSelect;
